(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fb-featured-carousel-v3"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initCarousel(section) {
      if (section.dataset.fbfcv3Init === 'true') return;
      section.dataset.fbfcv3Init = 'true';

      if ('IntersectionObserver' in window) {
        var animObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('fb-visible');
              animObserver.unobserve(entry.target);
            }
          });
        }, { threshold: 0.15 });
        section.querySelectorAll('.fb-anim-eyebrow, .fb-anim-title, .fb-anim-sub, .fb-anim-card, .fb-anim-cta')
          .forEach(function (el) { animObserver.observe(el); });
      } else {
        section.querySelectorAll('.fb-anim-eyebrow, .fb-anim-title, .fb-anim-sub, .fb-anim-card, .fb-anim-cta')
          .forEach(function (el) { el.classList.add('fb-visible'); });
      }

      var viewport = section.querySelector('.fbfcv3__viewport');
      var track = section.querySelector('.fbfcv3__track');
      var slides = Array.prototype.slice.call(section.querySelectorAll('.fbfcv3__slide'));
      var prevBtn = section.querySelector('.fbfcv3__arrow--prev');
      var nextBtn = section.querySelector('.fbfcv3__arrow--next');
      var dotsWrap = section.querySelector('.fbfcv3__dots');
      var wantsAutoplay = section.dataset.autoplay === 'true';
      var autoplaySpeed = parseInt(section.dataset.autoplaySpeed || '4000', 10);
      if (!viewport || !track || !slides.length) return;

      var currentPage = 0;
      var autoplayTimer = null;
      var userStopped = false;
      var isMobile = function () { return window.innerWidth <= 699; };
      var perView = function () { return isMobile() ? 2 : 6; };
      var pageCount = function () { return Math.max(1, Math.ceil(slides.length / perView())); };
      var maxIndex = function () { return Math.max(0, slides.length - perView()); };
      var pageStartIndex = function (p) { return Math.min(p * perView(), maxIndex()); };

      function stepWidth() {
        var gap = parseFloat(window.getComputedStyle(track).columnGap || 0);
        return slides[0].getBoundingClientRect().width + gap;
      }

      function buildDots() {
        dotsWrap.innerHTML = '';
        for (var i = 0; i < pageCount(); i++) {
          (function (idx) {
            var btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'fbfcv3__dot' + (idx === currentPage ? ' is-active' : '');
            btn.setAttribute('aria-label', 'Go to page ' + (idx + 1));
            btn.addEventListener('click', function () { haltByUser(); currentPage = idx; updateSlider(); });
            dotsWrap.appendChild(btn);
          })(i);
        }
      }

      function updateDots() {
        dotsWrap.querySelectorAll('.fbfcv3__dot').forEach(function (d, i) { d.classList.toggle('is-active', i === currentPage); });
      }

      function updateSlider(animate) {
        if (animate === undefined) animate = true;
        currentPage = Math.max(0, Math.min(currentPage, pageCount() - 1));
        var idx = pageStartIndex(currentPage);
        track.style.transition = animate ? 'transform 0.45s ease' : 'none';
        track.style.transform = 'translate3d(-' + (stepWidth() * idx) + 'px,0,0)';
        if (prevBtn) prevBtn.style.opacity = currentPage <= 0 ? '.4' : '1';
        if (nextBtn) nextBtn.style.opacity = currentPage >= pageCount() - 1 ? '.4' : '1';
        updateDots();
      }

      var nextPage = function (loop) { if (currentPage >= pageCount() - 1) { if (loop) { currentPage = 0; } } else { currentPage++; } updateSlider(); };
      var prevPage = function () { if (currentPage > 0) { currentPage--; } updateSlider(); };

      function startAutoplay() { if (!wantsAutoplay || userStopped) return; stopAutoplay(); autoplayTimer = setInterval(function () { nextPage(true); }, autoplaySpeed); }
      function stopAutoplay() { if (autoplayTimer) { clearInterval(autoplayTimer); autoplayTimer = null; } }
      function haltByUser() { userStopped = true; stopAutoplay(); }

      if (wantsAutoplay && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) { entries.forEach(function (entry) { (entry.isIntersecting && !userStopped) ? startAutoplay() : stopAutoplay(); }); }, { threshold: 0.2 });
        io.observe(section);
      } else if (wantsAutoplay) { startAutoplay(); }

      section.addEventListener('mouseenter', haltByUser);
      if (nextBtn) nextBtn.addEventListener('click', function () { haltByUser(); nextPage(false); });
      if (prevBtn) prevBtn.addEventListener('click', function () { haltByUser(); prevPage(); });

      var touchStartX = 0;
      viewport.addEventListener('touchstart', function (e) { touchStartX = e.changedTouches[0].clientX; haltByUser(); }, { passive: true });
      viewport.addEventListener('touchend', function (e) {
        var diff = touchStartX - e.changedTouches[0].clientX;
        if (Math.abs(diff) > 40) { diff > 0 ? nextPage(false) : prevPage(); }
      }, { passive: true });

      var resizeTimer;
      window.addEventListener('resize', function () { clearTimeout(resizeTimer); resizeTimer = setTimeout(function () { buildDots(); updateSlider(false); }, 120); });

      buildDots();
      updateSlider(false);
    }

    function initAll() {
      document.querySelectorAll('.fbfcv3').forEach(initCarousel);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
